import { ContractType } from '@received/pricing-model';
import { Contract } from '../ContractComponent/Contract';

export const ReferralAgreement = () => {
	return <Contract contractType={ContractType.REFERRAL} mainUrlToReturn='../referrals' />;
};
